export default "__VITE_ASSET__B5lV5$8z__"